import http from 'hub-http/clients/apiClient';
const CONTENT_ASSISTANCE_SETTINGS_URL = 'content-assistance/v1/settings';
export const fetchContentAssistanceSettings = () => {
  return http.get(CONTENT_ASSISTANCE_SETTINGS_URL);
};

/**
 * Supports Page Editor, Email Editor
 * Blog Post/Case Study contentId lookup always returns null BU ID
 */
export const fetchBrandVoiceByContentId = ({
  contentId
}) => {
  return http.get(`branding/v1/brand-voice/by-content-id/${contentId}`);
};